/**
 * True when the portal is running as an installed PWA (home screen / dock),
 * not a normal browser tab.
 */
export function isInstalledPwa(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false
  }

  const nav = navigator as Navigator & { standalone?: boolean }
  if (nav.standalone === true) {
    return true
  }

  if (!window.matchMedia) {
    return false
  }

  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches
  )
}
